/* Rugged Print, Module 10: SITE CHROME (header, Shop by Case menu, announcement bar, cart drawer, search, footer).
   CONTENT for both iterations. One object, read by chrome-core.js and chrome-1.js / chrome-2.js. In the theme each
   field becomes a section setting, a Shopify menu (Online Store > Navigation) or a Liquid object; the "src" notes say which.
   Facts: docs/BRAND-TRUTHS.md only. Links: every href is the production URL. What each one does in the LOCAL preview
   is decided in chrome-core.js (RPC.go), on top of Weaver's site link map (../site-links-2026-10-15/routes.js).
   No em or en dashes anywhere in this file's copy. */
(function(){
  var S = window.RP_SETTINGS || { freeShippingThreshold:100, bundleKitSize:3, bundleKitSavingPerItem:10 };
  var CDN = 'https://cdn.shopify.com/s/files/1/0743/4757/7434/files/';
  window.RPC_DATA = {
    settings: {
      freeShip: S.freeShippingThreshold,          // BRAND-TRUTHS §5, $65. NOT a live Shopify rule yet (see flags).
      freeShipRuleLive: false,                    // flip to true the day the real $65 automatic discount exists
      kitSize: S.bundleKitSize, kitPerItem: S.bundleKitSavingPerItem
    },
    /* src: announcement-bar section, one block per message */
    announce: [
      { id:'ship', icon:'fa-truck-fast', text:'Free shipping on orders $' + S.freeShippingThreshold + ' and up' },
      { id:'kit',  icon:'fa-layer-group', text:'Pick any ' + S.bundleKitSize + ', save $' + (S.bundleKitSaving || 10),
        href:'/collections/packout-inserts' }
    ],
    /* src: the two legacy announcement-bar sections already live above the real site's header today
       (site-archive/theme/sections/header-group.json, "announcement-bar" and "announcement_bar_scrolling_kPQWN4").
       Piyush, 2026-10-15, verbatim: keep these on the new chrome too, as their own rows stacked above the header,
       with no changes to the header itself. Text and image URLs are copied verbatim from that live section file,
       not re-authored. */
    topBars: {
      attention: {
        icon: 'fa-triangle-exclamation',
        text: 'ATTENTION: Our organizers are INSERTS ONLY unless otherwise stated. Items shown in photos are for demonstration purposes and are not included unless specifically listed or selected.'
      },
      comingSoon: {
        label: 'Coming Soon',
        items: [
          { img:'https://ruggedprint.com/cdn/shop/files/toughbuilt-logo_3a9f432f-8e8f-49f8-b83d-90a13aa3c7f5.png?v=1790154208', w:147, h:31, alt:'ToughBuilt' },
          { img:'https://ruggedprint.com/cdn/shop/files/DeWalt_Logo.svg?v=1790148918', w:106, h:38, alt:'DeWalt' }
        ]
      }
    },
    /* src: the live header's own logo file (Online Store > Theme settings > Logo, Gemini_Generated_Image_vdqde1...png,
       925x873 master), per Piyush's explicit ask (2026-10-15) to use the current site's own logo, not a different
       brand asset from brand/logos/. On the real site it only reads legibly because it gets a whole dedicated
       centered row of its own (the 5-row stack Piyush asked us to compress into one 56/64px bar). At that compact
       size the full icon+RUGGED+PRINT+tagline lockup turns to mush, so this is a PURE CROP (no regeneration, no
       compositing) down to just the top "RP" diamond mark, which is legible at header height and is still literally
       the same source file. Used consistently in all 3 compact chrome slots (header, mobile menu, footer) rather
       than the full lockup in some and the icon in others. Flagged back to Piyush, not a silent swap.
       usaBadge: the new Image Router badge (brand/image-generation/outputs/2026-10-15-made-in-usa-badge/), shipped
       here as the single @3x PNG at its real CSS display size (80x36) for retina sharpness without extra requests.
       Both uploaded to Shopify Files 2026-10-15 (fileCreate via staged upload) when this chrome went live on the
       3 preview pages; real CDN URLs below work identically in local preview and on the live theme, so there is
       no longer a separate local-vs-live path for these two images. */
    brandMark: {
      logo:'https://cdn.shopify.com/s/files/1/0743/4757/7434/files/rpc-logo-icon-mark.png?v=1792070528&width=160', logoW:645, logoH:492, logoIcon:'https://cdn.shopify.com/s/files/1/0743/4757/7434/files/rpc-logo-icon.png?v=1792842451', logoIconW:121, logoIconH:104, logoText:'https://cdn.shopify.com/s/files/1/0743/4757/7434/files/rpc-logo-wordmark.png?v=1792842455', logoTextW:360, logoTextH:89,
      usaBadge:'https://cdn.shopify.com/s/files/1/0743/4757/7434/files/rpc-made-in-usa-badge-a2.png?v=1792833675', usaBadgeW:288, usaBadgeH:109
    },
    /* src: main menu (Online Store > Navigation > main-menu). Shop by Case is a parent item with 4 children. */
    nav: [
      { label:'Shop by Case', menu:'cases' },
      { label:'Ammo', href:'/collections/ammo-organizers', key:'ammo' },
      { label:'Tools', href:'/collections/tool-organizers', key:'tool' },
    ],
    /* Case links. DEFAULT = the live master collection with its case filter (/collections/packout-inserts?case=...),
       which returns 200 today and REPLACES the four case hubs per docs/CHANGE-LOG.md (2026-10-15, master collection
       row). hubHref = the keyword-map hub URL (404 today), kept so the switch is one line if the hubs are built later.
       Photos: the homepage's own case set (same CDN files as /pages/home-preview). 8431 has no real photo: AI fallback,
       so any surface that shows it carries the verbatim disclosure. 4-Drawer: no photo and 0 live products. */
    caseLinkMode: 'filter',     // 'filter' (works at launch) or 'hub' (keyword-map hubs, 404 until built)
    cases: [
      { model:'48-22-8435', name:'Deep', holds:'Ammo and tool inserts',
        href:'/collections/packout-inserts?case=8435', hubHref:'/collections/packout-8435',
        img: CDN + 'case-8435-deep.png?v=1793780864', ai:false, alt:'Milwaukee PACKOUT 48-22-8435 deep organizer case, product photo' },
      { model:'48-22-8436', name:'Slim', holds:'Ammo inserts',
        href:'/collections/packout-inserts?case=8436', hubHref:'/collections/packout-8436',
        img: CDN + 'case-8436-slim.png?v=1793780881', ai:false, alt:'Milwaukee PACKOUT 48-22-8436 slim organizer case, product photo' },
      { model:'48-22-8431', name:'Double Slim', holds:'Ammo inserts',
        href:'/collections/packout-inserts?case=8431', hubHref:'/collections/packout-low-profile-8431',
        img: CDN + 'case-8431-double-slim.jpg?v=1793780896', ai:false,
        alt:'Milwaukee PACKOUT 48-22-8431 double slim organizer case, product photo' }
    ],
    shopLinks: [
      { label:'Ammo Organizers', href:'/collections/ammo-organizers' },
      { label:'Tool Organizers', href:'/collections/tool-organizers' },
      { label:'All PACKOUT Inserts', href:'/collections/packout-inserts' }
    ],
    disclosure: window.RP_DISCLOSURE || 'Images are for reference only. The actual product is built to the exact specifications in the description.',
    /* src: search. Popular terms are real catalog words (calibers and platforms that exist in the live catalog). */
    search: {
      placeholder:'Search caliber, tool or case model',
      popular:['9mm', '.223/5.56', '12 Gauge', '.308', 'M12', 'M18'],
      collections:[
        { title:'Ammo Organizers', url:'/collections/ammo-organizers', words:'ammo ammunition caliber rounds magazine mag 9mm 223 556 308 45 380 40 22 12 gauge shotgun shell' },
        { title:'Tool Organizers', url:'/collections/tool-organizers', words:'tool tools m12 m18 fuel drill driver impact router rivet stapler torch ratchet sander' },
        { title:'All PACKOUT Inserts', url:'/collections/packout-inserts', words:'packout insert inserts organizer 8435 8436 8431 case all' }
      ]
    },
    /* src: footer section group. Menus = Online Store > Navigation (footer-shop, footer-help, footer-company). */
    footer: {
      brandLine:'3D printed PETG inserts for Milwaukee PACKOUT cases. Printed to order in Arizona.',   // BRAND-TRUTHS §7 allowed claims
      shipLine:'Ships in 1 to 3 business days.',                                                     // BRAND-TRUTHS §7
      cols: [
        { h:'Shop by Case', cases:true },
        { h:'Shop', links:[
          { label:'Ammo Organizers', href:'/collections/ammo-organizers' },
          { label:'Tool Organizers', href:'/collections/tool-organizers' },
          { label:'All PACKOUT Inserts', href:'/collections/packout-inserts' },
          { label:'Magazine Inserts', href:'/collections/magazine-inserts' },
          { label:'M12 Tool Inserts', href:'/collections/m12-tool-inserts' },
          { label:'M18 Tool Inserts', href:'/collections/m18-tool-inserts' } ] },
        { h:'Help', links:[
          { label:'Contact Us', href:'/pages/contact' },
          { label:'FAQs', href:'/pages/faqs' },
          { label:'Shipping Policy', href:'/policies/shipping-policy' },
          { label:'Refund Policy', href:'/policies/refund-policy' },
          { label:'My Account', href:'/account' } ] },
        { h:'Company', links:[
          { label:'About Us', href:'/pages/about-us' },
           ] }
      ],
      legal: [
        { label:'Privacy Policy', href:'/policies/privacy-policy' },
        { label:'Terms of Service', href:'/policies/terms-of-service' },
        { label:'Your Privacy Choices', href:'/pages/data-sharing-opt-out' }
      ],
      nonAffiliation:'Rugged Print is not affiliated with or endorsed by Milwaukee Tool.',   // verbatim, homepage + PDP
      copyrightName:'Rugged Print',          // brand name; the legal entity is OPEN in BRAND-TRUTHS §1
      social: []                             // BRAND-TRUTHS §1: Facebook, Instagram, TikTok all OPEN. Do not invent.
    },
    /* Get Code: the SAME offer as the Ammo popup and the homepage Get Code section (Module 6 data.js A.popup). */
    offer: (window.RP_PAGES && window.RP_PAGES.ammo && window.RP_PAGES.ammo.popup) || {
      h:'10% Off Your First Order', sub:'Join the Rugged Print email list and get a code for 10% off your first order. No minimum spend.',
      emailLabel:'Email address', ph:'Your email address', btn:'Get My 10% Code', fine:'Unsubscribe any time.',
      doneH:'You are on the list.', doneSub:'Use this code at checkout on your first order:', code:'WELCOME10', codeIsPlaceholder:false
    },
    cart: {
      guarantee:'',
      taxLine:'Shipping and taxes are calculated at checkout.',
      emptyH:'Your cart is empty',
      emptySub:'Start with your case. Every insert is cut for one PACKOUT model.'
    }
  };
})();